import { ConnectorChannelIcon } from "#components/ui/ConnectorChannelIcon.tsx";
import { Channel } from "#features/channels/components/channels-details/Channel.tsx";
import { channelTypeToIntegration } from "#features/conversations/integrations/index.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import type { ConnectorChannelType } from "#types/types.ts";
import { Stack, Text } from "@hopper-ui/components";

interface Props {
    channelType: ConnectorChannelType;
}

export const ConnectedPersonalChannel = ({ channelType }: Props) => {
    const { tShared } = useSharedTranslation();
    const manifest = channelTypeToIntegration[channelType];

    if (!manifest) {
        return null;
    }

    return (
        <Channel
            icon={<ConnectorChannelIcon type={channelType} isPlateless />}
            title={tShared(manifest.nameKey)}
        >
            <Stack gap="inline-sm">
                {manifest.connectedContentKeys.map(key => (
                    <Text key={key} size="xs" color="neutral-weak">
                        {tShared(key)}
                    </Text>
                ))}
            </Stack>
        </Channel>
    );
};
